// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
export const environment = {
  production: false,
  urlParams: 'https://extapi.secmitie.co.uk/esme-chatautomation/v1-prod/postdata/gov', // APIS Dev
  urlParamsAgentPolling: 'https://sm-uks-gov-dev-esme-fa-002.gov.appserviceenvironment.net/api/LiveChat',
  urlParamsUserPolling: 'https://sm-uks-gov-dev-esme-fa-002.gov.appserviceenvironment.net/api/LiveChat',
  urlParamsNegotiate:'https://sm-uks-gov-dev-esme-fa-002.gov.appserviceenvironment.net/api/negotiate',
  apikey: '35283a3562d34997a62a8002047ae740', // FOR apis-dev
  urlParamsDform:'https://esmedynamicforms-dev.gov.secmitie.co.uk/api/getFormview?code=SW8/vF7034pRCVm4gSkpvBGN0Y/36nqTDm98AaBv9Kbp/2tVhtZZdA==',
  token:''
}